import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    color: Colors.GrayPallete.lightgrayThree,
    marginLeft: 5,
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
});
